import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  Label,
  Button,
  FormFeedback,
  Input,
  FormGroup,
} from "reactstrap";
import Dropzone from "react-dropzone";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Spinner from "components/spinner";
import { getServices } from "services/services.service";
import { createImageUrl } from "services/imageUrl.service";
import { CreateCaregory } from "services/V2_APIs/DoctorsConsultationApis/categories.service";

const defaultValues = {
  title: "",
  images: [],
  order: 0,
  status: "",
  condition: "",
  description: "",
  parentCategory: "",
  mobileBanners: [],
  suggestedServices: [],
};

const CreateCategory = ({ toggle, modal, reload, activeParentCatInd }) => {
  console.log(activeParentCatInd, "activeParentCatInd");
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [success_msg, setsuccess_msg] = useState(false);
  const [error_msg, seterror_msg] = useState(false);
  const [values, setValues] = useState(defaultValues);
  const [loading, setLoading] = useState(false);
  const [selectedParentCategory, setSelectedParentCat] = useState({});
  const [services, setServices] = useState([]);
  const [selectedService, setSelectedService] = useState([]);
  const [images, setImages] = useState([]);
  const [mobileBanners, setMobileBanners] = useState([]);
  console.log(mobileBanners, "mobileBanners");
  const statusList = [
    { label: "Active", value: "Active" },
    { label: "Inactive", value: "Inactive" },
  ];
  const initialValues = defaultValues;

  const validationSchema = Yup.object().shape({
    status: Yup.string().required("Please Select status"),
    image: Yup.string().required("Please Upload Image"),
  });
  useEffect(() => {
    if (activeParentCatInd) {
      setSelectedParentCat({
        label: activeParentCatInd?.name,
        value: activeParentCatInd?.name,
      });
    }
    getAllServices();
  }, [activeParentCatInd]);
  const onSubmit = values => {
    let payload = {
      ...values,
      parentCategory: activeParentCatInd?._id,
      status: selectedStatus?.value,
      suggestedServices: selectedService,
      images: images?.images,
      mobileBanners: mobileBanners?.mobileBanners,
    };
    console.log(payload, "vall");

    saveChanges(payload);
  };
  const buildOptions = list => {
    // console.log(list, "list");
    return list?.map(ele => ({
      label: ele?.name,
      value: ele?.name,
      id: ele?._id,
      type: ele?.type,
    }));
  };
  const getAllServices = () => {
    getServices()
      .then(res => {
        if (res) {
          let ActiveServices = res?.data.filter(
            ele => ele?.status === "Active" || ele?.status === "active"
          );
          setServices(buildOptions(ActiveServices));
        }
      })
      .catch(e => {
        console.log(e);
      });
  };
  const getColor = type => {
    if (type === "Female") return "#dd0a6c";
    if (type === "Male") return "#0c9ab5";
    return "black";
  };
  function handleSelectStatus(event) {
    setValues({ ...values, ["status"]: event.value });
    setSelectedStatus(event);
  }

  const saveChanges = body => {
    setLoading(true);
    CreateCaregory(body)
      .then(res => {
        if (res?.success === true) {
          setsuccess_msg(true);
        } else {
          seterror_msg(true);
        }
        setLoading(false);
        reload(activeParentCatInd?._id);
      })
      .catch(e => {
        console.log(e);
        seterror_msg(true);
        setLoading(false);
      });
  };

  function removeImage(index) {
    let imgArray = values["images"];
    imgArray.splice(index, 1);
    setValues({ ...values, ["images"]: imgArray });
    setImages({ ...values, ["images"]: imgArray });
  }

  const handleAcceptedImages = async images => {
    let obj = { ...values };

    if (obj.images.length < 7) {
      try {
        let imageFormData = new FormData();
        +imageFormData.set("image", images[0]);

        const data = await createImageUrl(imageFormData);

        if (data.success) {
          obj.images.push(data.image);
        }
        setImages({ ...obj });
      } catch (err) {
        console.log(err);
      }
    } else {
      alert("Maximum 7 Images are allowed");
    }
  };
  function removeMobileBanner(index) {
    let bannerArray = values["mobileBanners"];
    bannerArray.splice(index, 1);
    setValues({ ...values, ["mobileBanners"]: bannerArray });
    setMobileBanners({ ...values, ["images"]: imgArray });
  }

  const handleAcceptedMobileBanners = async acceptedFiles => {
    let obj = { ...values };

    for (const file of acceptedFiles) {
      try {
        let bannerFormData = new FormData();
        bannerFormData.set("image", file);

        const data = await createImageUrl(bannerFormData);

        if (data.success) {
          obj.mobileBanners.push(data.image); // assuming data.image is a URL or object
        }
        setMobileBanners({ ...obj });
      } catch (err) {
        console.error("Mobile banner upload failed:", err);
      }
    }

    setValues({ ...obj });
  };

  const leaveToList = () => {
    toggle();
    setsuccess_msg(false);
    seterror_msg(false);
    setValues(defaultValues);
    setSelectedStatus({});
  };
  const stayHere = () => {
    setsuccess_msg(false);
    seterror_msg(false);
  };

  const successPopup = () => {
    return (
      <SweetAlert
        title="Success"
        success
        onConfirm={leaveToList}
        onCancel={stayHere}
        customButtons={
          <React.Fragment>
            <Button
              color="primary"
              className="w-md btn-sm mx-1"
              onClick={leaveToList}
            >
              Leave
            </Button>
            <Button
              color="light"
              className="w-md btn-sm mx-1"
              onClick={stayHere}
            >
              Continue
            </Button>
          </React.Fragment>
        }
      >
        {"Successfully Category created"}
      </SweetAlert>
    );
  };

  const errorPopup = () => {
    return (
      <SweetAlert
        title="Failure"
        danger
        onConfirm={leaveToList}
        onCancel={stayHere}
        customButtons={
          <React.Fragment>
            <Button
              color="light"
              className="w-md btn-sm mx-1"
              onClick={leaveToList}
            >
              Leave
            </Button>
            <Button
              color="danger"
              className="w-md btn-sm mx-1"
              onClick={stayHere}
            >
              Continue
            </Button>
          </React.Fragment>
        }
      >
        Something went wrong
      </SweetAlert>
    );
  };

  return (
    <>
      <Spinner loading={loading} />
      <Modal isOpen={modal} toggle={toggle} backdrop="static" size="lg">
        <ModalHeader toggle={toggle}>{"Create Category"}</ModalHeader>
        <ModalBody className="bg-light">
          <Container fluid={false}>
            <Card>
              <CardBody>
                <Formik
                  enableReinitialize
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  // onSubmit={onSubmit}
                >
                  {({
                    errors,
                    touched,
                    isSubmitting,
                    setFieldValue,
                    handleChange,
                    setFieldTouched,
                    values,
                  }) => {
                    useEffect(() => {}, []);

                    return (
                      <Form>
                        <Row className="mt-4">
                          <Col md={6}>
                            <FormGroup className="mb-3">
                              <Label htmlFor="validationCustom01">Title</Label>
                              <Input
                                name="title"
                                placeholder="title"
                                type="text"
                                className="form-control"
                                id="title"
                                onChange={handleChange}
                                // onBlur={validation.handleBlur}
                                value={values.title}
                                invalid={
                                  touched.title && errors.title ? true : false
                                }
                              />

                              {touched.title && errors.title ? (
                                <FormFeedback type="invalid">
                                  {errors.title}
                                  {touched.title}
                                </FormFeedback>
                              ) : null}
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup className="mb-3">
                              <Label htmlFor="validationCustom01">
                                Condition
                              </Label>
                              <Input
                                name="condition"
                                placeholder="condition"
                                type="text"
                                className="form-control"
                                id="condition"
                                onChange={handleChange}
                                // onBlur={validation.handleBlur}
                                value={values.condition}
                                invalid={
                                  touched.condition && errors.condition
                                    ? true
                                    : false
                                }
                              />

                              {touched.condition && errors.condition ? (
                                <FormFeedback type="invalid">
                                  {errors.condition}
                                  {touched.condition}
                                </FormFeedback>
                              ) : null}
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <Label>Select Parent Category</Label>
                              <Select
                                name="parentCategory"
                                placeholder="Select..."
                                value={selectedParentCategory}
                                isDisabled
                              />
                              <Label className="statusValidation">
                                {errors.genderType ? errors.genderType : ""}
                              </Label>
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup className="mb-3">
                              <Label htmlFor="Status">Status</Label>
                              <Select
                                // className="form-control"
                                id="Status"
                                value={selectedStatus}
                                onChange={event => {
                                  handleSelectStatus(event);
                                  handleChange("status")(event.value);
                                }}
                                name="status"
                                options={statusList}
                                classNamePrefix="select2-selection"
                              />
                              <Label className="statusValidation">
                                {errors.status ? errors.status : ""}
                              </Label>
                            </FormGroup>
                          </Col>
                          <Col md={6} className="">
                            <FormGroup className="mb-3">
                              <Label htmlFor="validationCustom01">Order</Label>
                              <Input
                                name="order"
                                placeholder="Order"
                                type="text"
                                className="form-control"
                                id="order"
                                onChange={handleChange}
                                value={values.order}
                              />

                              {touched.name && errors.name ? (
                                <FormFeedback type="invalid">
                                  {errors.name}
                                  {touched.name}
                                </FormFeedback>
                              ) : null}
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <Label>Suggested Services</Label>
                              <Select
                                isMulti
                                name="serviceId"
                                placeholder="Select..."
                                value={selectedService}
                                onChange={selectedOptions => {
                                  setSelectedService(selectedOptions);
                                }}
                                options={services}
                                getOptionLabel={e => (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    {/* Dynamic Dot Color */}
                                    <span
                                      style={{
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        backgroundColor: getColor(e.type),
                                        display: "inline-block",
                                      }}
                                    ></span>
                                    {/* Service Name in Default Color */}
                                    <span style={{ color: "inherit" }}>
                                      {e.label}
                                    </span>
                                  </div>
                                )}
                                styles={{
                                  singleValue: provided => ({
                                    ...provided,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }),
                                  option: provided => ({
                                    ...provided,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }),
                                  multiValue: provided => ({
                                    ...provided,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                  }),
                                }}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={12} className="mt-3">
                            <Label>Description</Label>
                            <CKEditor
                              editor={ClassicEditor}
                              id="description"
                              data={values?.description || ""}
                              onReady={editor => {
                                if (values?.description)
                                  editor.data.set(values?.description);
                              }}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                setFieldValue("description", data);
                              }}
                            />
                          </Col>
                          <Row>
                            <Col md={6} className="mt-3">
                              <Label
                                htmlFor="firstname-Input"
                                className="col-form-label"
                              >
                                Images
                              </Label>
                              {/* <Col md={6} className=""> */}
                              <Dropzone
                                onDrop={acceptedImages => {
                                  handleAcceptedImages(acceptedImages);
                                }}
                              >
                                {({ getRootProps, getInputProps }) => (
                                  <div className="dropzone image_drop mt-1">
                                    <div
                                      className="dz-message needsclick"
                                      {...getRootProps()}
                                    >
                                      <input {...getInputProps()} />
                                      <div className="">
                                        <i className="display-6 text-muted bx bxs-cloud-upload" />
                                      </div>
                                      <h6>
                                        Drop files here or click to upload.
                                      </h6>
                                    </div>
                                  </div>
                                )}
                              </Dropzone>
                              {/* </Col> */}
                              <div>
                                <div
                                  className="dropzone-previews"
                                  id="file-previews"
                                >
                                  <div className="p-2">
                                    <Row className="align-items-center">
                                      {images.images &&
                                        images.images.length > 0 &&
                                        images.images.map((img, index) => {
                                          let { image } = img;
                                          return (
                                            <Col
                                              className="col-auto"
                                              sm={6}
                                              key={index}
                                            >
                                              <div
                                                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                                style={{
                                                  position: "relative",
                                                }}
                                              >
                                                <img
                                                  alt={"banner"}
                                                  src={img || image}
                                                  height="70"
                                                  width="60"
                                                  className=" rounded bg-light"
                                                />
                                                <i
                                                  style={{
                                                    position: "absolute",
                                                    right: "3px",
                                                    cursor: "pointer",
                                                    top: 0,
                                                  }}
                                                  className="mdi mdi-close-thick font-size-18 text-danger"
                                                  id="removeImgtooltip"
                                                  onClick={() =>
                                                    removeImage(index)
                                                  }
                                                />
                                              </div>
                                            </Col>
                                          );
                                        })}
                                    </Row>
                                  </div>
                                </div>
                              </div>
                            </Col>

                            <Col md={6} className="mt-3">
                              <Row className="">
                                <FormGroup className="mb-3 mt-3">
                                  <Label htmlFor="validationCustom06">
                                    Mobile Banners
                                  </Label>
                                  <div className="">
                                    <Dropzone
                                      onDrop={acceptedImages => {
                                        handleAcceptedMobileBanners(
                                          acceptedImages
                                        );
                                      }}
                                    >
                                      {({ getRootProps, getInputProps }) => (
                                        <div className="dropzone image_drop">
                                          <div
                                            className="dz-message needsclick"
                                            {...getRootProps()}
                                          >
                                            <input {...getInputProps()} />
                                            <div className="">
                                              <i className="display-6 text-muted bx bxs-cloud-upload" />
                                            </div>
                                            <h6>
                                              Drop files here or click to
                                              upload.
                                            </h6>
                                          </div>
                                        </div>
                                      )}
                                    </Dropzone>
                                    {/* <Col md={6}> */}
                                    <div
                                      className="dropzone-previews"
                                      id="mobile-file-previews"
                                    >
                                      <div className="p-2">
                                        <Row className="align-items-center">
                                          {mobileBanners?.mobileBanners &&
                                            mobileBanners?.mobileBanners
                                              .length > 0 &&
                                            mobileBanners?.mobileBanners.map(
                                              (img, index) => {
                                                let { image } = img;
                                                return (
                                                  <Col
                                                    className="col-auto"
                                                    sm={6}
                                                    key={index}
                                                  >
                                                    <div
                                                      className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                                      style={{
                                                        position: "relative",
                                                      }}
                                                    >
                                                      <img
                                                        alt={"banner"}
                                                        src={img || image}
                                                        height="70"
                                                        width="60"
                                                        className=" rounded bg-light"
                                                      />
                                                      <i
                                                        style={{
                                                          position: "absolute",
                                                          right: "3px",
                                                          cursor: "pointer",
                                                          top: 0,
                                                        }}
                                                        className="mdi mdi-close-thick font-size-18 text-danger"
                                                        id="removeImgtooltip"
                                                        onClick={() =>
                                                          removeMobileBanner(
                                                            index
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                  </Col>
                                                );
                                              }
                                            )}
                                        </Row>
                                      </div>
                                    </div>
                                    {/* </Col> */}
                                  </div>
                                </FormGroup>
                              </Row>
                            </Col>
                          </Row>
                        </Row>
                        <hr></hr>
                        <div className="d-flex justify-content-end">
                          <Button
                            color="light"
                            className="w-md btn-sm me-3"
                            onClick={leaveToList}
                          >
                            cancel
                          </Button>

                          <Button
                            color="primary"
                            className="w-md btn-sm"
                            type="submit"
                            onClick={() => onSubmit(values)}
                          >
                            Submit
                          </Button>
                        </div>
                      </Form>
                    );
                  }}
                </Formik>

                {success_msg ? successPopup() : null}
                {error_msg ? errorPopup() : null}
              </CardBody>
            </Card>
          </Container>
        </ModalBody>
      </Modal>
    </>
  );
};

export default CreateCategory;
